import ListView from "./ListView/ListView";

const AverageFruitMonitoring = () => <p>Average Fruit Monitoring</p>;

AverageFruitMonitoring.ListView = ListView;
export default AverageFruitMonitoring;
